export enum AnketaResourcesEnum {
  questionnaires = "questionnaires",
  organizations = "organizations",
  documentation = "documentation",
  mail = "mail",
  opsanio = "opsanio",
  // Opsanio per-feature ABAC resources (each with view/create/update/delete).
  opsanioUpdates = "opsanio/updates",
  opsanioContact = "opsanio/contact",
  opsanioAppliance = "opsanio/appliance",
  opsanioDocumentation = "opsanio/documentation",
  // Fleet-wide NetBox hardware inventory (opsanio > Hardware). Read-only, and
  // deliberately separate from `opsanio/appliance`: it exposes the whole spare
  // pool, not one customer's appliance.
  opsanioHardware = "opsanio/hardware",
  // Standalone infra operations (each matrix-driven, isInternal-gated). See
  // .claude/AUTH_RECOMMENDATION.md §5.
  opsanioBootstrap = "opsanio/bootstrap",
  opsanioPrtg = "opsanio/prtg",
  opsanioOtobo = "opsanio/otobo",
  // Dedicated read resource for the appliance flyout's Pangolin endpoints tab.
  opsanioPangolin = "opsanio/pangolin",
  // OPL / Regeltermine: per-appliance weekly meetings and their open-points list.
  opsanioOpl = "opsanio/opl",
  // See ALL appliances. Without it a user only sees the appliances whose
  // opsanio questionnaire lists them as a member.
  opsanioFleet = "opsanio/fleet",
  // The internal "Hardening" questionnaire section (per-cluster non-root
  // rollout switches). `view` shows it, `update` may change it - enforced on
  // the questionnaire PUT, not only in the UI.
  opsanioHardening = "opsanio/hardening",
  autonubil = "autonubil",
  medocinoSupport = "medocino/support",
}

// Resources that `extractToken` / `hasPermission` are wired to enforce server-side.
// Widened beyond questionnaires|organizations so the opsanio resources are
// enforced by the engine, not just the UI (AUTH_RECOMMENDATION.md §7.8).
export type AnketaResources =
  | AnketaResourcesEnum.questionnaires
  | AnketaResourcesEnum.organizations
  | AnketaResourcesEnum.opsanioUpdates
  | AnketaResourcesEnum.opsanioContact
  | AnketaResourcesEnum.opsanioAppliance
  | AnketaResourcesEnum.opsanioDocumentation
  | AnketaResourcesEnum.opsanioHardware
  | AnketaResourcesEnum.opsanioBootstrap
  | AnketaResourcesEnum.opsanioPrtg
  | AnketaResourcesEnum.opsanioOtobo
  | AnketaResourcesEnum.opsanioPangolin
  | AnketaResourcesEnum.opsanioOpl
  | AnketaResourcesEnum.opsanioFleet
  | AnketaResourcesEnum.opsanioHardening;
